<button
  class="flex cursor-pointer items-center gap-1 px-4 py-1 font-bold text-neutral-400 hover:bg-neutral-200 hover:text-neutral-500 disabled:cursor-default disabled:text-neutral-400 disabled:opacity-50"
  [attr.form]="form() ?? null"
  [attr.type]="type()"
  [disabled]="disabled()"
>
  <ng-content></ng-content>
</button>
